
<div class="player-header-container">
  <div class="player-hero">
    <div class="player-avatar">
      <mat-icon>account_circle</mat-icon>
    </div>
    <div class="player-identity">
      <h2 class="player-name">{{ Player.Player.LastName }}, {{ Player.Player.FirstName }}</h2>
      <p class="player-dob">{{ Player.Player.DateOfBirth | date: 'MMMM dd, yyyy' }}</p>
    </div>
  </div>

  <mat-divider class="header-divider"></mat-divider>

  <div class="player-stats-grid">
    <div class="stat-card">
      <mat-icon class="stat-icon">cake</mat-icon>
      <div class="stat-content">
        <span class="stat-label">{{"PLAYER.AGE" | translate}}</span>
        <span class="stat-value">{{ Player.PlayerAgeYears }}y {{ Player.PlayerAgeMonths }}m</span>
      </div>
    </div>

    <div class="stat-card">
      <mat-icon class="stat-icon">height</mat-icon>
      <div class="stat-content">
        <span class="stat-label">{{"PLAYER.HEIGHT" | translate}}</span>
        <span class="stat-value">{{ Player.Player.Height }} cm</span>
      </div>
    </div>

    <div class="stat-card">
      <mat-icon class="stat-icon">fitness_center</mat-icon>
      <div class="stat-content">
        <span class="stat-label">{{"PLAYER.WEIGHT" | translate}}</span>
        <span class="stat-value">{{ Player.Player.Weight }} kg</span>
      </div>
    </div>

    <div class="stat-card">
      <mat-icon class="stat-icon">sports_hockey</mat-icon>
      <div class="stat-content">
        <span class="stat-label">{{"PLAYER.SHOOTS" | translate}}</span>
        <span class="stat-value">
          @if (Player.Player.ShootId === 1) {
            <span>{{"GENERAL.LEFT" | translate}}</span>
          }
          @if (Player.Player.ShootId === 2) {
            <span>{{"GENERAL.RIGHT" | translate}}</span>
          }
          @if (!Player.Player.ShootId || (Player.Player.ShootId !== 1 && Player.Player.ShootId !== 2)) {
            <span>-</span>
          }
        </span>
      </div>
    </div>
  </div>
</div>
